import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Math = () => {
  return (
    <StartInterviewLayout type="math"/>
  )
}

export default Math;